module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3xfJm"))).then(() => parcelRequire('d0iPb'));